module.exports = __webpack_public_path__ + "media/icons/search-white-48d6514b.svg";